import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Mail, Loader2, CheckCircle } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { authAPI } from '@/lib/api-client'
import { EnlevoLogo } from '@/components/EnlevoLogo'

export function PendingVerification() {
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email') || ''
  const [isResending, setIsResending] = useState(false)
  const [resent, setResent] = useState(false)

  const handleResend = async () => {
    if (!email) {
      toast.error('Email não encontrado.')
      return
    }
    setIsResending(true)
    try {
      await authAPI.resendVerification(email)
      setResent(true)
      toast.success('Email reenviado com sucesso!')
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Erro ao reenviar email')
    } finally {
      setIsResending(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mb-6">
          <EnlevoLogo size="md" />
        </div>
        <div className="rounded-lg bg-white p-8 shadow-sm border border-neutral-200">
          <div className="mx-auto h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
            <Mail className="h-8 w-8 text-blue-600" />
          </div>
          <h2 className="text-2xl font-semibold text-neutral-900">Verifique seu Email</h2>
          <p className="mt-3 text-neutral-600">
            Enviamos um link de confirmação para:
          </p>
          {email && (
            <p className="mt-1 font-medium text-neutral-800">{email}</p>
          )}
          <p className="mt-4 text-sm text-neutral-500">
            Clique no link do email para ativar sua conta. O link expira em 24 horas.
          </p>

          <div className="mt-6 space-y-3">
            <Button
              variant="outline"
              className="w-full"
              onClick={handleResend}
              disabled={isResending || resent}
            >
              {isResending ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Reenviando...
                </>
              ) : resent ? (
                <>
                  <CheckCircle className="mr-2 h-4 w-4 text-green-500" />
                  Email Reenviado
                </>
              ) : (
                'Reenviar Email'
              )}
            </Button>
            <Link to="/login">
              <Button variant="ghost" className="w-full mt-2">
                Voltar para Login
              </Button>
            </Link>
          </div>

          <p className="mt-6 text-xs text-neutral-400">
            Verifique sua caixa de spam caso não encontre o email.
          </p>
        </div>
      </div>
    </div>
  )
}
